import { DEFAULT_PAGE_SIZE } from '../constants';

export const DEFAULT_PAGE_INFO = {
  pageInfo: {
    pageIndex: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    total: 0
  }
};

export interface PageInfo {
  pageIndex: number;
  pageSize: number;
  total: number;
}
